<template>
  <a-modal
    title="操作"
    :width="600"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          label="项目名称"
        >
          <a-input v-decorator="['title', {}]" />
        </a-form-item>

        <a-form-item
          label="项目描述"
        >
          <a-textarea rows="3" v-decorator="['description', {}]" @keyup.enter="handleOk" />
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import { createItem, editItem } from '@/api/item'
export default {
  name: 'ProjectModal',
  data () {
    return {

      labelCol: {
        xs: { span: 12 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 14 },
        sm: { span: 10 }
      },
      visible: false,
      confirmLoading: false,
      mdl: {},
      isAdd: false,
      itemId: '',
      label_type: ''
    }
  },
  beforeCreate () {
    this.form = this.$form.createForm(this)
  },
  created () {

  },
  methods: {
    add () {
      this.disabled = false
      this.visible = true
      this.form.setFieldsValue({ title: '', description: '' })
      this.isAdd = true
    },
    edit (item) {
      this.itemId = item.itemId
      this.label_type = item.originData.label_type
      this.mdl = Object.assign({}, item)
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue({ ...item })
      })
    },
    close () {
      this.confirmLoading = false
      this.visible = false
      this.isAdd = false
    },
    handleOk () {
      const _this = this
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          if (_this.isAdd) {
            var data = {}
            data.item_name = values.title
            data.item_des = values.description
            createItem(data).then(res => {
            // Do something
              _this.$message.success('新建成功')
              _this.$emit('item_changed', res.data)
            }).catch(() => {
              _this.$message.success('新建失败')
            }).finally(() => {
              _this.close()
            })
            _this.confirmLoading = true
          } else {
            var data = {}
            data.item_id = _this.itemId
            data.item_name = values.title
            data.item_des = values.description
            data.label_type = _this.label_type
            editItem(data).then(res => {
              _this.$message.success('修改成功')
              _this.$emit('item_changed', res.data)
            }).catch(() => {
              _this.$message.success('修改失败')
            }).finally(_this.close)
            _this.confirmLoading = true
          }
        }
      })
    },
    handleCancel () {
      this.close()
    }

  }
}
</script>
